window.arjoDownLoadItemModule = window.arjoDownLoadItemModule || {
  isInitialized: false,
  init: function () {
    if (this.isInitialized) {
      return;
    }
    this.isInitialized = true;
    let downloadItems = [...document.querySelectorAll('.arjo-m-download-item')];
    downloadItems.forEach((downloadItem, downloadIndex) => {
      let languageSelector = downloadItem.querySelector('.arjo-m-download-item__action-button .arjo-m-dropdown');
      let downloadButton = downloadItem.querySelector('.arjo-m-download-item__action-button .arjo-a-link');

      downloadItem.style.setProperty('--download-item-index', downloadItems.length - downloadIndex);

      downloadButton.addEventListener('click', (e) => {
        const el = e.target;

        const name = el.name?.trim() || el.id || el.getAttribute('class');

        const filename = el.href.split('/').reverse()[0];

        const params = { fileName: filename, name: name, linkText: el.innerText };

        window.GA4.analyticsGa4.DownloadTracker.pushDownload(params);
      });
      languageSelector.addEventListener('change', function (e) {
        let selectVal = e.target.value;
        if (!selectVal) {
          downloadButton.setAttribute('href', '');
          downloadButton.removeAttribute('download');
          downloadButton.setAttribute('disabled', '');
        } else {
          downloadButton.setAttribute('href', selectVal);
          downloadButton.setAttribute('download', '');
          downloadButton.removeAttribute('disabled');
        }
      });
    });
  },
};
window.addEventListener('load', function () {
  window.arjoDownLoadItemModule.init();
});
